import { Table } from 'react-bootstrap';
import styled from 'styled-components';

export const FlatTable = styled(Table)`
  tr:nth-of-type(odd) td {
    background: #fafafa;
  }

  tr:hover td {
    background: #f7f7f7;
  }

  td {
    transition: 150ms ease background;
  }
`;
